import { Component, OnInit, Input } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-modal-header',
  templateUrl: './overlay-header.component.html',
  styleUrls: ['./overlay-header.component.scss'],
})
export class OverlayHeaderComponent implements OnInit {
  /**
   * Se TRUE l'icona e' quella di chiusura anziché navigazione 
   * all'indietro (quando l'overlay e' un azione autonoma rispetto
   * al flusso applicativo)
   */
  @Input() isAction: boolean = false;
  /**
   * Se TRUE l'header viene applicato ad un popover anziche' ad
   * un completo modal
   * (pilota la chiusura)
   */
  @Input() isPopover: boolean = false;

  @Input() title: string = 'Pagina XYZ';

  constructor(
    private modalController: ModalController,
    private popoverController: PopoverController) { }

  ngOnInit() {}

  chiudiModal() {
    if (this.isPopover) {
      this.popoverController.dismiss();
    } else {
      this.modalController.dismiss();
    }
  }

}
